<template>
  <v-container class="main-container responsive-height create-investor-account-details">
    <v-row dense>
      <v-col cols="12" md="3">
        <v-card tile flat class="TitleCard" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-sheet class="mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <h2 class="mt-0">
                    {{ managerDetails?.st_username || "N/A" }}
                  </h2>
                  <p class="mb-0">
                    <span class="text--green">{{
                      managerDetails?.accountAge
                    }}</span>
                    Days
                  </p>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-row dense>
          <v-col cols="12">
            <v-card flat class="profile-card rounded-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
              <div class="user-profile">
                <div class="profile-image">
                  <v-badge avatar bordered overlap color="black accent-4" icon="mdi-star-outline">
                    <v-avatar size="47">
                      <v-img src="../../assets/avatar.png"></v-img>
                    </v-avatar>
                  </v-badge>
                </div>
                <v-btn small tile elevation="0" :to="{
              path: '/create-investor-account-auth',
              query: {
                id: this.managerId,
                type: this.managerType,
              },
            }"
                  class="ma-0 text-capitalize btn-account mt-5" color="greenMain">
                  Invest On Me
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="5">
        <v-card tile flat class="balanceCard" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-sheet class="d-flex mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <div class="title">
                    <v-icon dense color="#5F7692">mdi-bag-checked</v-icon>
                    <span class="ml-2">Total Trades</span>
                    <p class="number mb-0 text--green">
                      {{ managerDetails?.totalClosedTrade.toFixed(2) || 0 }}
                      <strong>
                        ({{
                          managerDetails?.allTimeProfit.toFixed(2) || "0.00"
                        }}
                        USD)</strong>
                    </p>
                  </div>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <v-card-text class="d-flex pl-0 pb-2 mt-4 pr-0 trade align-center">
                  <p class="equity">
                    <span class="mb-2 d-inline-block">Profitable: </span>
                    {{ managerDetails?.totalPositiveProfit?.toFixed(2) || 0 }}
                    ({{
                      managerDetails?.totalPositiveProfit === null
                        ? null
                        : (managerDetails?.totalPositiveProfit.toFixed(2) /
                          managerDetails?.totalClosedTrade.toFixed(2)) *
                        100
                    }}%)
                    <br />
                    <span class="mb-2 d-inline-block">Non Profitable: </span>
                    {{ managerDetails?.totalNegativeProfit.toFixed() || 0 }}({{
                      managerDetails?.totalNegativeProfit === null
                        ? null
                        : (managerDetails?.totalNegativeProfit.toFixed() /
                          managerDetails?.totalClosedTrade.toFixed()) *
                        100
                    }}%)
                  </p>
                  <v-spacer></v-spacer>
                  <p class="equity text-right">
                    <span class="mb-2 d-inline-block">Buy: </span>
                    {{ managerDetails?.totalBuyTrades || 0 }}({{
                      managerDetails?.totalBuyTrades === null
                        ? null
                        : (managerDetails?.totalBuyTrades /
                          managerDetails?.totalClosedTrade) *
                        100
                    }}%)
                    <br />
                    <span class="mb-2 d-inline-block">Sell: </span>
                    {{ managerDetails?.totalSellTrades || 0 }}
                    ({{
                      managerDetails?.totalSellTrades === null
                        ? null
                        : (managerDetails?.totalSellTrades /
                          managerDetails?.totalClosedTrade) *
                        100
                    }}%)
                  </p>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card tile flat class="balanceCard" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-sheet class="d-flex mb-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <div class="title">
                    <v-icon dense color="#5F7692">mdi-bag-checked</v-icon>
                    <span class="ml-2">All Time Profit</span>
                    <p class="number mb-0 text--green">
                      {{ managerDetails?.allTimeProfit?.toFixed(2) || "0.00" }}
                      <strong>USD</strong>
                    </p>
                  </div>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <v-card-text class="d-flex pl-0 pb-2 mt-4 pr-0 trade align-center">
                  <p class="equity">
                    <span class="mb-2 d-inline-block">This mo. profit: </span>
                    {{ managerDetails?.thisMonthProfit?.toFixed(2) || "0.00" }}
                    <br />
                    <span class="mb-2 d-inline-block">Profit Share:</span>
                    {{ managerDetails?.profit_sharing?.toFixed(2) || "N/A" }}%
                  </p>
                  <v-spacer></v-spacer>
                  <p class="equity text-right">
                    <span class="mb-2 d-inline-block">Max. Profit: </span>
                    {{ managerDetails?.maxProfit?.toFixed(2) || 0 }}
                    <br />
                    <span class="mb-2 d-inline-block">Max. Loss:</span>
                    {{ managerDetails?.maxLoss?.toFixed(2) || 0 }}
                  </p>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="3" lg="2">
        <v-select solo :items="this.managerDetails?.symbols ? this.managerDetails.symbols : []" v-model="selectedSymbol" append-icon="mdi-chevron-down" label="Symbols"
          class="custom-select"></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-select solo v-model="time" :items="dateOptions" item-text="label" item-value="value" label="Select date"
          append-icon="mdi-chevron-down" class="custom-select"></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0 chart-tab" :color="$vuetify.theme.dark ? '#172233' : '#E0EAF2'">
          <v-card-title class="pt-0">
            <v-icon dense color="#5F7692" class="mr-3">mdi-bag-checked</v-icon>
            Profit / Loss History
          </v-card-title>
          <v-sheet class="pb-3" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#E8F1F8'">
            <apexChart width="100%" height="338px" type="bar" :options="chartOptions" :series="series"
              class="liveTradeChart">
            </apexChart>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="3" lg="2">
        <v-select solo :items="buySellList" v-model="selectedBuySellType" append-icon="mdi-chevron-down"
          label="Buy / Sell" class="custom-select"></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-select solo v-model="buySellTime" :items="date" label="Select date" append-icon="mdi-chevron-down"
          class="custom-select"></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0 chart-tab" :color="$vuetify.theme.dark ? '#172233' : '#E0EAF2'">
          <v-card-title class="pt-0">
            <v-icon dense color="#5F7692" class="mr-3">mdi-bag-checked</v-icon>
            Buy / Sale History
          </v-card-title>
          <v-sheet class="pb-3" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#E8F1F8'">
            <apexChart width="100%" height="338px" type="bar" :options="buySellChartOptions" :series="buySellSeries"
              class="liveTradeChart">
            </apexChart>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { CHARTS__ACTIONS, TRADING__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      managerId:"",
      managerType: "",
      date: null,
      options: {
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false,
          },
          background: "#162334",
        },
        xaxis: {
          labels: {
            style: {
              colors: "#708AA7",
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: "#708AA7",
            },
            formatter: (value) => {
              if (value >= 1000) return `${(value / 1000).toFixed(1)}k`;
              return value.toFixed(1);
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          crosshairs: {
            show: true,
            position: "back",
            stroke: {
              color: "#b6b6b6",
              width: 1,
              dashArray: 0,
            },
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "40%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          show: true,
          showForSingleSeries: true,
          customLegendItems: ["Profit / Loss"],
          labels: {
            colors: ["#647E98"],
            useSeriesColors: false,
          },
          markers: {
            fillColors: ["#14D7B2", "#647E98"],
            radius: 12,
          },
        },
      },
      buySellOptions: {
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false,
          },
          background: "#162334",
        },
        xaxis: {
          labels: {
            style: {
              colors: "#708AA7",
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: "#708AA7",
            },
            formatter: (value) => {
              if (value >= 1000) return `${(value / 1000).toFixed(1)}k`;
              return value.toFixed(1);
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          crosshairs: {
            show: true,
            position: "back",
            stroke: {
              color: "#b6b6b6",
              width: 1,
              dashArray: 0,
            },
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "40%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          show: true,
          showForSingleSeries: true,
          customLegendItems: ["Buy / Sell"],
          labels: {
            colors: ["#647E98"],
            useSeriesColors: false,
          },
          markers: {
            fillColors: ["#14D7B2", "#647E98"],
            radius: 12,
          },
        },
      },
      selectedSymbol: null,
      selectedBuySellType: null,
      time: "last-week",
      buySellTime: "last-week",
      dateOptions: [
        { label: "Last Week", value: "last-week" },
        { label: "Last Month", value: "last-month" },
        { label: "Last Year", value: "last-year" }
      ]
    };
  },
  computed: {
    ...mapState("trading", ["managerDetails"]),
    ...mapState("charts", [
      "managerInvestorProfitLoss",
      "managerInvestorBuySell",
    ]),

    chartOptions() {
      return {
        ...this.options,
        tooltip: {
          enabled: true,
          custom: ({ series, seriesIndex, dataPointIndex, w }) => {
            const value = series[seriesIndex][dataPointIndex];
            if (value === 0) {
              return "";
            }
            return (
              '<div class="arrow_box">' +
              "<span>" +
              value.toFixed(2) +
              "</span>" +
              "</div>"
            );
          },
        },
        xaxis: {
          ...this.options.xaxis,
          categories: this.managerInvestorProfitLoss?.labels || [],
        },
      };
    },

    buySellChartOptions() {
      return {
        ...this.buySellOptions,
        tooltip: {
          enabled: true,
          custom: ({ series, seriesIndex, dataPointIndex, w }) => {
            const value = series[seriesIndex][dataPointIndex];
            if (value === 0) {
              return "";
            }
            return (
              '<div class="arrow_box">' +
              "<span>" +
              value.toFixed(2) +
              "</span>" +
              "</div>"
            );
          },
        },
        xaxis: {
          ...this.buySellOptions.xaxis,
          categories: this.managerInvestorBuySell?.labels || [],
        },
      };
    },

    series() {
      const chartData = this.managerInvestorProfitLoss?.data || [];
      const allZero = chartData.every(
        (item) => parseFloat(item.totalProfit) === 0
      );

      const seriesData = [
        {
          name: "Amount",
          data: chartData?.map((item) => {
            let value = parseFloat(item.totalProfit);
            if (allZero) {
              value = 0.001;
            }
            return {
              x: item.Time.split("-").reverse().join("."),
              y: allZero ? value : Math.abs(value),
              fillColor: allZero
                ? "#1C2C40"
                : value > 0
                  ? "#14D7B2"
                  : "#647E98",
            };
          }),
        },
      ];

      return seriesData;
    },

    buySellSeries() {
      const chartData = this.managerInvestorBuySell?.data || [];
      const allZero = chartData.every(
        (item) => parseFloat(item.totalProfit) === 0
      );

      const seriesData = [
        {
          name: "Amount",
          data: chartData?.map((item) => {
            let value = parseFloat(item.totalProfit);
            if (allZero) {
              value = 0.001;
            }
            return {
              x: item.Time.split("-").reverse().join("."),
              y: allZero ? value : Math.abs(value),
              fillColor: allZero
                ? "#1C2C40"
                : value > 0
                  ? "#14D7B2"
                  : "#647E98",
            };
          }),
        },
      ];

      return seriesData;
    },
    // symbols() {
    //   return ["All", this.managerDetails.symbols || []];
    // },
    buySellList() {
      return ["All", "Buy", "Sell"];
    },
  },
  methods: {
    ...mapActions("trading", [TRADING__ACTIONS.VIEWMANAGERDETAILS]),
    ...mapActions("charts", [
      CHARTS__ACTIONS.MANAGERINVESTORPROFITLOSSCHART,
      CHARTS__ACTIONS.MANAGERINVESTORBUYSELLCHART,
    ]),

    async fetchChartData(data) {
      await this[CHARTS__ACTIONS.MANAGERINVESTORPROFITLOSSCHART](data);
    },
    async fetchBuySellChartData(data) {
      await this[CHARTS__ACTIONS.MANAGERINVESTORBUYSELLCHART](data);
    },
  },
  watch: {
    async time(newTime, oldTime) {
      if (newTime !== oldTime) {
        try {
          const data = {
            id: this.$route.query.id,
            symbol: null,
            time: newTime,
          };
          await this.fetchChartData(data);
        } catch (error) {
          console.error(error);
        }
      }
    },
    async buySellTime(newTime, oldTime) {
      if (newTime !== oldTime) {
        try {
          const data = {
            id: this.$route.query.id,
            buySellType: null,
            time: newTime,
          };
          await this.fetchBuySellChartData(data);
        } catch (error) {
          console.error(error);
        }
      }
    },
    async selectedSymbol(newSymbol, oldSymbol) {
      if (newSymbol !== oldSymbol) {
        try {
          const data = {
            id: this.$route.query.id,
            symbol: newSymbol === "All" ? null : newSymbol,
            time: this.time,
          };
          await this.fetchChartData(data);
        } catch (error) {
          console.error(error);
        }
      }
    },
    async selectedBuySellType(newD, oldD) {
      if (newD !== oldD) {
        try {
          const data = {
            id: this.$route.query.id,
            buySellType: newD === "All" ? null : newD === "Sell" ? 1 : 0,
            time: this.buySellTime,
          };
          await this.fetchBuySellChartData(data);
        } catch (error) {
          console.error(error);
        }
      }
    },
  },
  async mounted() {
    await this[TRADING__ACTIONS.VIEWMANAGERDETAILS](this.$route.query.id);
    await this[CHARTS__ACTIONS.MANAGERINVESTORPROFITLOSSCHART]({
      id: this.$route.query.id,
      symbol: null,
      time: this.time,
    });
    await this[CHARTS__ACTIONS.MANAGERINVESTORBUYSELLCHART]({
      id: this.$route.query.id,
      buySellType: null,
      time: this.buySellTime,
    });
  },

  created(){
    const url = new URLSearchParams(window.location.search);
    this.managerId =  url.get('id');
    this.managerType =  url.get('type');
  }
};
</script>
